import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { Card, Modal, Button, Icon, Empty, Checkbox, Tag } from "antd";
import { AddressRecord } from "records/company-record";
import AddAddressForm from "forms/add-address-form";
import AddressDisplay from "components/address-display";
import { PermissionContextManager } from "hocs/permission-context-manager";
import { ADDRESSES_TYPES } from "constants/enums";
import { STATE_STATUS } from "constants/state-status";
import LoaderSkeleton from "components/loader-skeleton";
import { UI_PERMISSIONS } from "constants/index";

class AddressCard extends React.Component {
    state = {
        status: this.props.status,
        addressEditing: false
    };
    formRef = React.createRef();
    address = null;
    toggleModal = () => {
        this.setState({
            addressEditing: !this.state.addressEditing
        });
    };
    addAddress = () =>
        this.formRef.current.validateFields((err, values) => {
            if (!err) {
                this.toggleModal();
                this.props.update(
                    this.props.companyId,
                    this.props.type,
                    new AddressRecord({
                        id: this.props.address ? this.props.address.id : null,
                        company: this.props.companyId,
                        associate: null,
                        ...values
                    })
                );
            }
        });
    replicateOptionalAddress = () =>
        this.props.update(
            this.props.companyId,
            this.props.type,
            new AddressRecord({
                ...this.props.optionalAddress
                    .toSeq()
                    .toMap()
                    .filter((_, k) =>
                        [
                            "ownership_type",
                            "residing_since",
                            "address_line_1",
                            "address_line_2",
                            "city",
                            "state",
                            "pincode",
                            "is_communication_address",
                            "ownership_type"
                        ].includes(k)
                    )
                    .toJS(),
                id: this.props.address ? this.props.address.id : null,
                company: this.props.companyId,
                associate: null,
                address_type: ADDRESSES_TYPES.get(this.props.type)
            })
        );
    renderActions() {
        let base_actions = 
        this.props.isUserAllowedToEdit && 
        this.props.optionalAddressLabel && 
        this.props.permissionContext  && 
        this.props.permissionContext.find((_,k) => 
            k === UI_PERMISSIONS.ADDRESS_EDIT
        ) && !this.props.recreditViewOnlyPermission 
            ? [
                <Checkbox
                    disabled={!this.props.optionalAddress}
                    key={"optional-address"}
                    onChange={this.replicateOptionalAddress}
                >
                    {this.props.optionalAddressLabel}
                </Checkbox>
            ]
            : [];

        return this.props.address && !this.props.recreditViewOnlyPermission 
            ? [
                ...base_actions,
                <Button
                    type={"link"}
                    key={"edit"}
                    disabled={!this.props.ADDRESS_EDIT}
                    onClick={this.toggleModal}
                >
                      Edit <Icon type={"edit"} />
                </Button>
            ]
            : !this.props.recreditViewOnlyPermission ? [
                ...base_actions,
                <Button
                    type={"link"}
                    key={"edit"}
                    disabled={!this.props.ADDRESS_EDIT}
                    onClick={this.toggleModal}
                >
                      Add Address <Icon type={"plus"} />
                </Button>
            ] : [];
    }

    isLoading = () => {
        return (
            [
                STATE_STATUS.UNFETCHED,
                STATE_STATUS.FETCHING,
                STATE_STATUS.UPDATING
            ].includes(this.state.status) || !this.state.status
        );
    };

    componentDidUpdate() {
        if (this.state.status !== this.props.status) {
            this.setState({
                status: this.props.status
            });
        }
    }
    render() {
        const {
            props: { address, type, title },
            state: { addressEditing }
        } = this;

        return (
            <React.Fragment>
                <Modal
                    visible={addressEditing}
                    maskClosable={true}
                    title={`Add ${title} Address`}
                    width={800}
                    onCancel={this.toggleModal}
                    destroyOnClose={true}
                    okText={"Submit"}
                    onOk={this.addAddress}
                >
                    <AddAddressForm
                        ref={this.formRef}
                        values={
                            address
                                ? address
                                : new Map({
                                    address_type: ADDRESSES_TYPES.get(type)
                                })
                        }
                        addressTypes={[type]}
                    />
                </Modal>
                <Card
                    title={title}
                    className={"padless-card"}
                    extra={this.renderActions()}
                >
                    <LoaderSkeleton loading={this.isLoading()}>
                        {!address ? (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        ) : (
                            <div className={"px-10 py-32"}>
                                <Tag color="#108ee9">{address.ownership}</Tag>
                                <AddressDisplay address={address} />
                            </div>
                        )}
                    </LoaderSkeleton>
                </Card>
            </React.Fragment>
        );
    }
}

AddressCard.propTypes = {
    companyId: PropTypes.number,
    title: PropTypes.string,
    type: PropTypes.string, // Address Type (Operating | Regsitered)
    address: PropTypes.object,
    optionalAddress: PropTypes.object,
    optionalAddressLabel: PropTypes.string,
    status: PropTypes.string,
    update: PropTypes.func,
    ADDRESS_EDIT: PropTypes.bool,
    permissionContext: PropTypes.object,
    isUserAllowedToEdit: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default PermissionContextManager({
    permission: UI_PERMISSIONS.ADDRESS_VIEW,
    propsPermissions: {
        ADDRESS_EDIT: UI_PERMISSIONS.ADDRESS_EDIT
    }
})(AddressCard);
